if (!customElements.get('c-mega-menu')) {
  class CMegaMenu extends HTMLElement {
    connectedCallback() {
      this.listeners = [];
      this.hoverTimer = null;
      this.suppressFocusOpen = false;
      this.menuItem = null;

      if (!this.classList.contains('c-mm--mobile')) {
        this.bindDropdownKeyboard();
      }
      this.bindTabs();
    }

    disconnectedCallback() {
      this.listeners.forEach(([el, type, fn]) => el.removeEventListener(type, fn));
      this.listeners = [];
      clearTimeout(this.hoverTimer);
      if (this.menuItem && this.menuItem.dataset.cMmBound === this.dataset.blockId) {
        delete this.menuItem.dataset.cMmBound;
      }
      this.menuItem = null;
    }

    on(el, type, fn) {
      el.addEventListener(type, fn);
      this.listeners.push([el, type, fn]);
    }

    /* Open/close the theme dropdown from the keyboard by replaying the
       mouseenter/mouseleave events the theme's SiteNav already listens to,
       so hover delay, animation and overlay stay identical. */
    bindDropdownKeyboard() {
      const item = this.closest('.m-menu__item');
      if (!item || item.dataset.cMmBound) return;
      item.dataset.cMmBound = this.dataset.blockId || '1';
      this.menuItem = item;

      const isOpen = () => item.classList.contains('m-menu__item--active');
      const open = () => {
        if (!isOpen()) item.dispatchEvent(new MouseEvent('mouseenter'));
      };
      const close = () => {
        if (isOpen()) item.dispatchEvent(new MouseEvent('mouseleave'));
      };

      this.on(item, 'focusin', () => {
        if (this.suppressFocusOpen) return;
        open();
      });

      this.on(item, 'focusout', (event) => {
        const next = event.relatedTarget;
        if (next && item.contains(next)) return;
        if (item.matches(':hover')) return;
        close();
      });

      this.on(item, 'keydown', (event) => {
        if (event.key !== 'Escape' || !isOpen()) return;
        close();
        const topLink = item.querySelector('.m-menu__link--main');
        if (topLink) {
          this.suppressFocusOpen = true;
          topLink.focus();
          this.suppressFocusOpen = false;
        }
      });
    }

    bindTabs() {
      const tablist = this.querySelector('[role="tablist"]');
      if (!tablist) return;
      const tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
          t.classList.toggle('is-active', active);
          const panelId = t.getAttribute('aria-controls');
          const panel = panelId ? this.querySelector('#' + CSS.escape(panelId)) : null;
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      };

      tabs.forEach((tab) => {
        this.on(tab, 'click', () => select(tab, false));
        this.on(tab, 'focus', () => {
          if (tab.getAttribute('aria-selected') !== 'true') select(tab, false);
        });
        this.on(tab, 'mouseenter', () => {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => select(tab, false), 60);
        });
        this.on(tab, 'mouseleave', () => clearTimeout(this.hoverTimer));
      });

      this.on(tablist, 'keydown', (event) => {
        const current = tabs.indexOf(document.activeElement);
        if (current < 0) return;
        let next = -1;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            next = (current + 1) % tabs.length;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            next = (current - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        select(tabs[next], true);
      });
    }
  }

  customElements.define('c-mega-menu', CMegaMenu);
}
